module.exports = __webpack_public_path__ + "img/case-ct_revoltcapsule.a078087.png";